"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.version = void 0; // replaced during build with the latest version in package.json

exports.version = '1.0.10';